import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import React from 'react';
import { createContext, useContext, useMemo } from 'react';

export const StickyNavBarOffsetContext = createContext<{
  offset: number;
}>({
  offset: 0,
});

interface BannersOffsetArgs
  extends Readonly<{
    changesReminderBanner: boolean;
    unpublishedWebsiteBanner: boolean;
  }> {}

const CHANGES_REMINDER_BANNER_HEIGHT_DESKTOP = 56;
const CHANGES_REMINDER_BANNER_HEIGHT_MOBILE = 75;
const UNPUBLISHED_WEBSITE_BANNER_HEIGHT_MOBILE = 56;
const UNPUBLISHED_WEBSITE_BANNER_HEIGHT_DESKTOP = 80;

export const useBannersOffset = ({ changesReminderBanner, unpublishedWebsiteBanner }: BannersOffsetArgs) => {
  const isMobileOrTablet = useIsMobileScreen();

  return useMemo(() => {
    let offset = 0;

    if (changesReminderBanner) {
      offset += isMobileOrTablet ? CHANGES_REMINDER_BANNER_HEIGHT_MOBILE : CHANGES_REMINDER_BANNER_HEIGHT_DESKTOP;
    }

    if (unpublishedWebsiteBanner) {
      offset += isMobileOrTablet ? UNPUBLISHED_WEBSITE_BANNER_HEIGHT_MOBILE : UNPUBLISHED_WEBSITE_BANNER_HEIGHT_DESKTOP;
    }

    return offset;
  }, [changesReminderBanner, unpublishedWebsiteBanner, isMobileOrTablet]);
};

interface StickyNavBarOffsetProviderProps
  extends Readonly<{
    offset: number;
  }> {}

export const StickyNavBarOffsetProvider: React.FC<StickyNavBarOffsetProviderProps> = ({ children, offset }) => {
  return <StickyNavBarOffsetContext.Provider value={{ offset }}>{children}</StickyNavBarOffsetContext.Provider>;
};

export const useStickyNavBarOffset = () => {
  return useContext(StickyNavBarOffsetContext);
};
